import type { ExpenseStatementTotals } from '../types/zonalStatement.types';

export const STATEMENT_PERSON_ROLE_LABEL = 'ZM';

type ExpenseHeadKey = Exclude<keyof ExpenseStatementTotals, 'total'>;

interface ExpenseHead {
  key: ExpenseHeadKey;
  label: string;
}

export const EXPENSE_HEADS: readonly ExpenseHead[] = [
  { key: 'ta', label: 'T.A.' },
  { key: 'teacherEntertainment', label: 'T.Entertainment' },
  { key: 'pb', label: 'P.B.' },
  { key: 'da', label: 'D.A.' },
  { key: 'other', label: 'Other' },
];
